import React from 'react';
import Translate from '../../../components/Translate';
import './charts.css';

/*
 * One captioned chart.
 *
 * Holds the title, the fixed-height drawing area every ResponsiveContainer
 * needs, and the message that replaces the drawing when a filter has left
 * nothing to draw - which is the common case on this page, not an edge one: a
 * date range of one quiet morning empties most of these charts.
 *
 * `isEmpty` is asked of the caller rather than worked out here, because empty
 * means something different per chart - no rows for one, every row at zero for
 * another. The footer goes with the drawing and not with the message: a legend
 * for slices that are not there explains nothing.
 */
const ChartBlock = ({titleKey, hintKey, isEmpty, emptyKey = 'noChartData', height, footer, children}) => (
    <div className="chart-block">
        {/* optional: a chart sitting under a section heading that already names
            it does not want a second title of its own */}
        {titleKey && <h3 className="chart-block__title"><Translate text={titleKey}/></h3>}
        {hintKey && <p className="chart-block__hint"><Translate text={hintKey}/></p>}

        <div className="chart-block__canvas" style={height ? {height: height} : undefined}>
            {isEmpty
                ? <div className="chart-empty"><Translate text={emptyKey}/></div>
                : children}
        </div>

        {!isEmpty && footer ? footer : null}
    </div>
);

export default ChartBlock;



// WEBPACK FOOTER //
// ./src/components-new/general/charts/ChartBlock.jsx